import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_30: FaireProductEntity = {
  token: "catalog_prod_prod-30",
  type: "product",
  name: "Storage Container",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 79.32,
  msrpDollars: 198.3,
  sku: "PA0030",
  caseSize: 4,
  material: "Glass",
  collectionToken: "col_pattern-play",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: true,
  inStock: true,
  stockLevel: 339,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_games-puzzles"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
